import React, { useMemo } from 'react';
import {
  useScenarioOrTotalProgramExportable,
  useWorksheet,
} from 'spw-programming-projects/downloads/exportables/hooks';
import BuildingHCSCScenario from 'spw-components/programming-scenarios/building-hs-sc-scenario/index';
import styled from 'styled-components';

const Content = styled.div`
  > div > div {
    margin-top: 0;
  }
`;

const SeatCountAnalysisExportable: React.FunctionComponent = () => {
  const {
    isTotalProgram,
    currentScenario,
    currentProject,
  } = useScenarioOrTotalProgramExportable();

  const { worksheet } = useWorksheet(isTotalProgram);

  const shouldRender = useMemo(() => {
    let isAllDataAvailable = Boolean(currentScenario?.id && currentProject?.id);

    if (isTotalProgram) {
      isAllDataAvailable = Boolean(isAllDataAvailable && worksheet);
    }

    return isAllDataAvailable;
  }, [currentScenario, currentProject, worksheet, isTotalProgram]);

  return shouldRender ? (
    <Content className="content">
      <BuildingHCSCScenario isRenderingForExport />
    </Content>
  ) : null;
};

export default SeatCountAnalysisExportable;
